$(document).ready(function() {

	$("#select-material-button").click(function(e) {
		$("#select-material-menu").toggleClass('active');
	});


	$('#comparison-select-company').selectmenu({
		classes: {
			"ui-selectmenu-menu": "comparison-select"
		}
	});
	$('#comparison-select-material').selectmenu({
		classes: {
			"ui-selectmenu-menu": "comparison-select"
		}
	});


	$('.filter-options .filter-select').on('change', function () {
		updateQueryParam(this.name, this.value);
	});

	$('.material-table-section .filter-button').on('click', function (e) {
		e.preventDefault();
		const checked = $('.check.active');

		let location = '/graphite-materials/compare/?';
		for (const input of checked) {
			location += 'materials[]=' + input.dataset.material + '&';
		}

		location = location.substring(0, location.length - 1);

		window.location = location;
	});


	$('#select-material').on('change', function() {
		window.location = this.value;
	});
});


function updateQueryParam(param, value) {
	const params = new URLSearchParams(window.location.search);
	params.set(param, value);

	window.location.search = params.toString();
}